/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Enum representing different Power Platform cloud environments.
 */
export enum PowerPlatformCloud {
  /**
   * Unknown cloud environment.
   */
  Unknown = 'Unknown',
  /**
   * Experimental cloud environment.
   */
  Exp = 'Exp',
  /**
   * Development cloud environment.
   */
  Dev = 'Dev',
  /**
   * Test cloud environment.
   */
  Test = 'Test',
  /**
   * Pre-production cloud environment.
   */
  Preprod = 'Preprod',
  /**
   * First release cloud environment.
   */
  FirstRelease = 'FirstRelease',
  /**
   * Production cloud environment.
   */
  Prod = 'Prod',
  /**
   * Government cloud environment.
   */
  Gov = 'Gov',
  /**
   * High security cloud environment.
   */
  High = 'High',
  /**
   * Department of Defense cloud environment.
   */
  DoD = 'DoD',
  /**
   * Mooncake cloud environment.
   */
  Mooncake = 'Mooncake',
  /**
   * Ex cloud environment.
   */
  Ex = 'Ex',
  /**
   * Rx cloud environment.
   */
  Rx = 'Rx',
  /**
   * Private cloud environment.
   */
  Prv = 'Prv',
  /**
   * Local cloud environment.
   */
  Local = 'Local',
  /**
   * French government cloud environment.
   */
  GovFR = 'GovFR',
  /**
   * Other cloud environment.
   */
  Other = 'Other',
}
